import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { deleteJournalById, getAllJournals } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
import DataGrid from "../../components/DataGrid";

const Journal = () => {
  const navigate = useNavigate();
  const { storeG, userPermID } = useStateContext();
  const [AllJournals, setAllJournals] = useState("");
  const [Journal, setJournal] = useState(null);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const handleRowSelected = (args) => setJournal(args.data);
  const journalIdCol = (props) => <div>{"J" + props.journal_id}</div>;
  const creditCol = (props) => (
    <div>{props.type_id === 902 ? formatCurrency(props.amount) : `-`}</div>
  );
  const debitCol = (props) => (
    <div>{props.type_id === 901 ? formatCurrency(props.amount) : `-`}</div>
  );

  const journalsGrid = [
    {
      headerText: "ID",
      field: "journal_id",
      template: journalIdCol,
      minWidth: "90",
      width: "90",
      maxWidth: "100",
      textAlign: "right",
    },
    {
      field: "datetime",
      headerText: "DateTime",
      type: "dateTime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "150",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "account",
      headerText: "Account",
      minWidth: "180",
      width: "200",
      maxWidth: "420",
      textAlign: "left",
    },
    {
      headerText: "Debit",
      template: creditCol,
      minWidth: "140",
      width: "140",
      maxWidth: "180",
      textAlign: "right",
    },
    {
      headerText: "Credit",
      template: debitCol,
      minWidth: "140",
      width: "140",
      maxWidth: "180",
      textAlign: "right",
    },
    {
      field: "notes",
      headerText: "Note",
      minWidth: "140",
      width: "320",
      maxWidth: "640",
      textAlign: "left",
    },
  ];

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  const handleAddJournalClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    navigate(`/Journal/AddJournal`);
  };

  const handleEditJournalClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (Journal && Journal.journal_id !== "")
      navigate(`/Journal/EditJournal/${Journal.journal_id}`);
    else showInfoToast("Info!", "Please select journal to edit.");
  };

  const handleDeleteJournalClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (Journal && Journal.journal_id !== "") {
      var j_id = Journal.journal_id;
      if (window.confirm(`Are you sure you want to delete J${j_id} journal?`)) {
        const resp = await deleteJournalById(j_id);
        if (resp.success) {
          showSuccessToast("Success!", "Journal deleted successfully.");
          window.location.reload();
        } else showErrorToast("Error!", "Journal failed to delete.");
      }
    } else showInfoToast("Info!", "Please select journal to delete.");
  };

  const handleViewJourClick = () => {
    TimeoutUtility.resetTimeout();
    if (Journal && Journal.journal_id !== "")
      navigate(`/Journal/ViewJournal/${Journal.journal_id}`);
    else showInfoToast("Info!", "Please select Journal to view!");
  };

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      const resp = await getAllJournals(storeG.store_id);
      setAllJournals(resp.data || []);
    }
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (storeG?.store_id)
        trackPromise(
          getAllJournals(storeG.store_id)
            .then((result) => setAllJournals(result.data || []))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
    }
    fetchData();
  }, [storeG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header category="Financials" title="JOURNAL" />
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(38) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddJournalClick} />
            </Col>
          )}
          {userPermID.includes(39) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditJournalClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Delete" onClick={handleDeleteJournalClick} />
              </Col>
            </>
          )}
        </Row>
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllJournals}
        cols={journalsGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(37) && handleViewJourClick}
        persistant={true}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Journal;
